import { getValidAccessToken } from 'services/Api/refreshHelper';
import { API_URL } from 'settings';

export async function downloadAssetsByTiers(signal: AbortSignal) {
  const token = await getValidAccessToken();
  if (signal.aborted) return;
  const headers = new Headers();
  if (token) headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(
    `${API_URL}/asset_catalogue/assets/download-by-tiers/`,
    { method: 'GET', headers, signal },
  );
  if (!response.ok) {
    throw new Error('Could not download assets by tiers. Please try again.');
  }
  const blob = await response.blob();
  if (signal.aborted) return;
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'assets_by_tiers.csv';
  document.body.appendChild(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    URL.revokeObjectURL(url);
  }
}
